var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1671 5.83203L26.7138 11.632L25.4338 11.9787C24.8338 10.8187 24.2204 9.6587 23.5138 9.07203C22.8071 8.4987 21.9804 8.4987 21.1671 8.4987H17.8338V22.4987C17.8338 23.1654 17.8338 23.832 18.2738 24.1654C18.7271 24.4987 19.6071 24.4987 20.5004 24.4987V25.832H12.5004V24.4987C13.3938 24.4987 14.2738 24.4987 14.7271 24.1654C15.1671 23.832 15.1671 23.1654 15.1671 22.4987V8.4987H11.8338C11.0204 8.4987 10.1938 8.4987 9.48711 9.07203C8.78044 9.6587 8.16711 10.8187 7.56711 11.9787L6.28711 11.632L7.83378 5.83203H25.1671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.561ea94600fc64cd8cd3b41f67162ba5.svg";
export { ForwardRef as ReactComponent };